<template>
	<div
		v-bind:class="[
			{
				'builder-element': !onPreview,
				'hide-desktop': node.options.visible_desktop,
				'hide-mobile': node.options.visible_mobile,
			},
			node.class,
		]"
		:id="node.id"
		:data-key="node.key"
		:data-elIcon="node.icon"
		:data-elName="node.name"
		:data-type="node.type"
		@click="onNodeClick(node)"
		:style="getWrapperStyle(node)"
	>
		<NodeAction :node="node" component="element" v-if="!onPreview" />

		<div>
			<ImageSlider
				:banners="sliders"
				:interval="interval"
				:autoplay="autoplay"
				:show-nav="true"
				:dots="true"
				image-size="original"
				:transition="transition"
			/>
		</div>
	</div>
</template>

<script>
import NodeAction from '@/components/funnels/pagebuilder/nodes/NodeAction.vue';
import {
	getNodeStyle,
	// eslint-disable-next-line
} from '@/lib/helper';
// eslint-disable-next-line
import ImageSlider from '@/components/funnels/pagebuilder/parts/ImageSlider.vue';

export default {
	name: 'NodeSlider',
	props: ['node', 'onPreview', 'previewDevice'],
	components: {
		NodeAction,
		ImageSlider,
	},
	data() {
		return {
			isLoading: true,
		};
	},
	computed: {
		sliders() {
			let items = [];
			if (this.node && this.node.options && this.node.options.content) {
				items = this.node.options.content.filter(curr => curr.is_visible);
			}
			return items;
		},
		autoplay() {
			return this.node?.options?.autoplay;
		},
		transition() {
			return this.node?.options?.transition ?? 'fade';
		},
		interval() {
			const interval = this.node && this.node.options && this.node.options.interval
				? parseInt(this.node.options.interval)
				: 5;
			return interval;
		},
	},
	methods: {
		getStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'text-color',
				'font-family',
				'font-weight',
				'font-size',
				'font-style',
				'text-decoration',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},
		getWrapperStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'margin',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},
		getImageUrl(item) {
			const placeholder = 'https://place-hold.it/600x400';
			const imgUrl = item && item.src ? item.src : placeholder;
			return imgUrl;
		},
		onNodeClick(node) {
			this.handleAction('edit', node);
		},
		handleAction(type, node) {
			this.$bus.$emit('action-element', type, node);
		},
	},
};
</script>

<style scoped></style>
